<div class="period-status-badge period-status-badge--{{type}}">
    <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'closed'">{{TEXT.periodStatus.closed}}</ng-container>
        <ng-container *ngSwitchCase="'opened'">{{TEXT.periodStatus.opened}}</ng-container>
        <ng-container *ngSwitchCase="'planned'">{{TEXT.periodStatus.planned}}</ng-container>
    </ng-container>
</div>
